export { default as MegaMenuLink } from './megaMenuLink'



// WEBPACK FOOTER //
// ./src/components/header/desktopHeader/megaMenu/index.js